import { gsap } from 'gsap';

const MARQUEE_DURATION = 16; // s — time for one full right-to-left pass across the screen.

/**
 * Classic marquee, looping from page load: the "What kind of housing for
 * what kind of society?" repeat in the home page's second section slides
 * in as a single line from off-screen right, crawls at a constant speed
 * across the full viewport width, and exits off-screen left — then
 * restarts from the right, seamlessly, forever.
 * @param {HTMLElement} container Section containing `[data-animate="cascade-right"]`.
 */
export function initWordCascadeRight( container ) {
	if ( ! container ) {
		return;
	}

	const textEl = container.querySelector( '[data-animate="cascade-right"]' );

	if ( ! textEl ) {
		return;
	}

	// Waits for webfonts: the real font can render noticeably wider/narrower
	// than the fallback, and `scrollWidth` below needs the true rendered
	// width to compute a distance that fully clears both edges.
	document.fonts.ready.then( () => {
		const startLeft = textEl.getBoundingClientRect().left;

		// `scrollWidth`, not `getBoundingClientRect().width`: the element's
		// own box is only as wide as its container (it's stretched by the
		// flex column parent), while `white-space: nowrap` lets the actual
		// text overflow that box — scrollWidth is what captures the full
		// rendered line so the exit distance clears the whole phrase, not
		// just the box.
		const textWidth = textEl.scrollWidth;

		gsap.fromTo(
			textEl,
			// Start with the line's own left edge pushed out past the
			// viewport's right edge, so no part of it is visible yet.
			{ x: window.innerWidth - startLeft },
			{
				// End once the line's right edge (startLeft + full width)
				// has cleared the viewport's left edge (x = 0).
				x: -( startLeft + textWidth ),
				ease: 'none',
				duration: MARQUEE_DURATION,
				repeat: -1,
			}
		);
	} );
}
